export default "__VITE_ASSET__5c877cf5__"